import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CircleIconDirective } from './circle-icon.directive';
import { DownArrowIconDirective } from './down-arrow-icon.directive';
import { RemoveIconDirective } from './remove-icon.directive';
import { SearchIconDirective } from './search-icon.directive';
import { PlusIconComponent } from './plus-icon/plus-icon.component';
import { OvalIconComponent } from './oval-icon/oval-icon.component';
import { SettingsIconComponent } from './settings-icon/settings-icon.component';
import { DragIconComponent } from './drag-icon/drag-icon.component';
import { DownloadIconComponent } from './download-icon/download-icon.component';
import { ArrowIconComponent } from './arrow-icon/arrow-icon.component';
import { SearchIconComponent } from './search-icon/search-icon.component';
import { SentStatusIconComponent } from './sent-status-icon/sent-status-icon.component';
import { ArrowRightIconComponent } from './arrow-right-icon/arrow-right-icon.component';


@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [
    CircleIconDirective,
    DownArrowIconDirective,
    RemoveIconDirective,
    SearchIconDirective,
    PlusIconComponent,
    OvalIconComponent,
    SettingsIconComponent,
    DragIconComponent,
    DownloadIconComponent,
    ArrowIconComponent,
    SearchIconComponent,
    SentStatusIconComponent,
    ArrowRightIconComponent,
  ],
  exports: [
    CircleIconDirective,
    DownArrowIconDirective,
    RemoveIconDirective,
    SearchIconDirective,
    PlusIconComponent,
    OvalIconComponent,
    SettingsIconComponent,
    DragIconComponent,
    DownloadIconComponent,
    ArrowIconComponent,
    SearchIconComponent,
    SentStatusIconComponent,
    ArrowRightIconComponent,
  ]
})
export class IconModule {
  static forRoot(): ModuleWithProviders<any> {
    return {
      ngModule: IconModule,
      providers: []
    };
  }
}
